import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import Wrapper from '../../components/Wrapper/Wrapper';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
    getDriverLedger, getDriverLedgerV2, getSparklineTotalBalances
} from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import TopCard from '../../components/TopCard/TopCard'
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';

const Drivers = ({ user, dispatchFetchAllDrivers, dispatchGetSparklineBalances }) => {
    const classes = useStyles();
    let history = useHistory();
    const [driverLedgerData, setDriverLedgerData] = useState([]);
    const [addDriverModalOpen, setDriverModalOpen] = useState(false);
    const [driverNameModalOpen, setDriverNameModalOpen] = useState(false);
    const [recall, setRecall] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [sparklineData, setSparklineData] = useState({});
    const [loadingText, setLoadingText] = useState("Sorry, no Drivers found");

    const driverLedgerRequestData = {
        fleetOwnerId: user.userInfo.entityId,
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
    };
    const onSearchBlur = debounce(query => {
        setDriverLedgerData([]);
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo)
        dispatchFetchAllDrivers({ ...driverLedgerRequestData, searchText: query },
            () => {
                setLoadingText("Sorry, no Drivers found");
            },
            () => {
                setLoadingText("Sorry, no Drivers found");
            }
        )
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
    const getPaginatedData = () => {
        const driverPaginatedReqData = {
            fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
            pageNo: currentPageNo + 1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge: true
        };
        dispatchFetchAllDrivers(driverPaginatedReqData);
    }
    useEffect(() => {
        setLoadingText("Sorry, no Drivers found");
        dispatchFetchAllDrivers(driverLedgerRequestData,
            (data) => {

                if (data && data.status && data.status.code == 200) {
                    logger.log("Drivers dWeb", "Fetch all drivers successfull");
                    dispatchGetSparklineBalances(
                        () => {
                            logger.log("Drivers dWeb", "Get Sparkline Balances Successfull");
                        },
                        () => {
                            logger.log("Drivers dWeb", "Get Sparkline Balances Failed");
                        }
                    )
                }

            },
            () => {
                logger.log("Drivers dWeb", "Fetch all drivers failed");
            }
        )
    }, [
        dispatchFetchAllDrivers, recall
    ]);

    useEffect(() => {
        if (user.driverLedgerData && user.driverLedgerData.driverLedgerDataResponse) {
            setDriverLedgerData(user.driverLedgerData.driverLedgerDataResponse);
        }
        if (user.sparklineTotalBalance) {
            setSparklineData(user.sparklineTotalBalance)
        }
    }, [user.driverLedgerData, user.sparklineTotalBalance]);

    // const goDriverGave = () => {
    //     setDriverNameModalOpen(true);
    // }

    const handleAddPartyClick = () => {
        setDriverModalOpen(true);
    }

    const handleDriverRow = (index) => {
        if (index == 0 || index) {
            const driverId = driverLedgerData[index].id;
            const driverName = driverLedgerData[index].name;
            const status = driverLedgerData[index].status;

            history.push({
                pathname: `/drivers/single-driver/${driverId}`,
                state: {
                    id: 8,
                    driverStatus: status || null,
                    pageTitle: driverName ? driverName : 'Driver View',
                    driverId: driverId
                }
            });

        }
    }
    // const handleAddPartyModalClose = (status) => {
    //     setDriverModalOpen(status);
    // }

    // const handlePartySave = (status) => {
    //     if (status) {
    //         dispatchFetchAllDrivers(driverLedgerRequestData, () => {
    //         }, () => {
    //         })
    //     }
    // }

    // const handleAddDriverModalClose = () => {
    //     setDriverModalOpen(false);
    // }

    // const handleOnConfirm = () => {
    //     setDriverModalOpen(false);
    //     setRecall(!recall);
    // }

    // const handleDriverGaveModelClose = () => {
    //     setDriverNameModalOpen(false);
    // }

    const muiColumns = [
        {
            name: "name",
            label: "Driver Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowIndex = tableMeta.rowIndex;
                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {
                                        if (user && user.driverLedgerData && user.driverLedgerData.maxPage && user.driverLedgerData.maxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <span className={classes.fw300}>{value}</span>
                            </Fragment>
                        );
                    } else {
                        return <span className={classes.fw300}>{value}</span>
                    }
                }
            },
        },
        {
            name: "contactNumber",
            label: "Phone Number",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fw300}>{value ? "+91 " + value : "N/A"}</span>
                }
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.statusDiv}> <FiberManualRecordIcon
                            className={value == 'AVAILABLE' ? classes.circle : classes.circleOnTrip}
                        ></FiberManualRecordIcon><div className={classes.statusV1}>{value == "ONTRIP" ? "On Trip" : value.toLowerCase()}</div></div>
                    )
                }
            },
        },
        {
            name: "driverBalance",
            label: "Balance",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fw300} >{numberFormat(Number(value))}</span>
                }
            },
        },

    ];
    const muiData = driverLedgerData;
    const options = {
        rowsPerPage: 100,
        pagination: false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleDriverRow(rowMeta.dataIndex);
        },
        customToolbar: (data) => {
            return <>


            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            //value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        onSearchChange: (val) => {
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value)
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("")
            }else{
                setSearchText("");
                onSearchBlur("")
            }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            /*if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach(col => {
                    if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }*/
            return true;
        },
        searchPlaceholder: 'Search Drivers',
        textLabels: {
            body: {
                noMatch: loadingText,
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };
    return (<Wrapper>
        <Paper className={classes.pageContentDIv} elevation={3}>
            <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
                <Grid item>
                    <TopCard title='Total Driver Balance' infoTitle='Total Driver Balance' infoText='The total amount to be collected or paid to all the drivers'
                        color="#0b1323" infoIcon={true} cardValue={numberFormat(sparklineData && sparklineData.driver_balance ? sparklineData.driver_balance : 0)} />
                </Grid>
            </Grid>
            <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
        </Paper>
    </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchFetchAllDrivers: (data, onSuccess, onFailure) => (dispatch(getDriverLedgerV2(data, onSuccess, onFailure))),
    dispatchGetSparklineBalances: (onSuccess, onFailure) => {
        dispatch(getSparklineTotalBalances(onSuccess, onFailure))
    }
});
const DriversWithRouter = withRouter(Drivers);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriversWithRouter);